import { Injectable } from '@angular/core';
import { TalonarioAit } from '@tivic-team/manager-ts/dist/mob/entities/ait/talonario-ait.entity';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';


@Injectable()
export class TalonarioAitController{

    constructor() {}

	async get(cdTalao:number):Promise<TalonarioAit>{		
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/talonarios/:cdTalao',
					environment: environment,
					pathParams: new JSONData({cdTalao: cdTalao})
				}),
			}),
			new HttpResponse(
				new TalonarioAit()
			)
		);
		return await quark.call();
	}

    
    async find(filtros?:IFilter):Promise<Array<TalonarioAit>>{
        let quark = new Quark(
            new HttpGet({
                url:new Url({
                    id: 'mob/talonarios',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<TalonarioAit>()
            )
        );
        
        return await quark.call();
    }

    async create( talonarioAit: TalonarioAit ): Promise<TalonarioAit> {
        let quark = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/talonarios/transporte/valid',
                    environment: environment
                }),
                data: new JSONData( talonarioAit )
            }),
            new HttpResponse(
                new TalonarioAit()
            )
        );

        return await quark.call();

    }

    async update( talonarioAit: TalonarioAit ): Promise< TalonarioAit > {
        let quark = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/talonarios/transporte/valid/:cdTalao',
                    environment: environment,
                    pathParams: new JSONData({ cdTalao: talonarioAit.cdTalao }),
                }),
                data: new JSONData( talonarioAit )
            }),
            new HttpResponse(
                new TalonarioAit()
            )
        );
        return await quark.call();
    }
}